/**
 * Created by Lucas on 07-May-18.
 */

export default {
  API_URL: process.env.API_HOST ? process.env.API_HOST + '/api/' : 'https://mw.local/api/', // 'https://cloud-api.masterdaweb.com/api/', //
  BASE_URL: process.env.API_HOST, // 'https://cloud-api.masterdaweb.com/', //
  COOKIE_DOMAIN: process.env.COOKIE_DOMAIN,
  COOKIE_NAME_PREFIX: process.env.COOKIE_NAME_PREFIX,
  NEW_FRONTEND_HOST: process.env.NEW_FRONTEND_HOST,
  CLIENT_AREA () {
    return localStorage.getItem('whmcs_base_url')
  }
}



// WEBPACK FOOTER //
// ./src/services/configs.js